import React from 'react';
import { Progress, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import new1Bg from "../../../assets/images/new1Bg.png";
import neoLogo from "../../../assets/images/Neo_Logo_A.svg";
import GamificationBadges from "./GamificationBadges";
import moment from "moment";
import { useKioskGamification } from "../hooks/useKioskGamification";

const KioskGamificationProfile = ({ member, onBack }) => {
    const {
        liveMember,
        latestEvaluation,
        groupedCriteria,
        gamifiedActivities,
        achievementsSettings,
        rankSettings,
        awardedAchievementIds,
        awardedAchievements,
        loadingEval,
        activeTab,
        levels,
        actions: { setActiveTab }
    } = useKioskGamification(member);
    const photo = liveMember?.photoUrl || liveMember?.photo || null;
    const name = liveMember?.fullName || "Aluno(a)";
    const points = liveMember?.xpTotal || liveMember?.XP || 0;
    const level = (liveMember?.activityNames && liveMember?.activityNames.length > 0) ? liveMember?.activityNames[0] : "Iniciante";

    return (
        <div
            className="w-100 flex-grow-1 d-flex flex-column position-relative"
            style={{
                backgroundColor: "#001D3D", // Fallback color for underwater theme
                backgroundImage: `url(${new1Bg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundAttachment: 'fixed',
                minHeight: '100vh',
                overflowY: 'auto',
                paddingBottom: '100px'
            }}
        >
            {/* Overlay leve para preservar o brilho do fundo ao usar painéis frosted glass */}
            <div style={{
                position: 'fixed',
                top: 0, left: 0, right: 0, bottom: 0,
                backgroundColor: 'rgba(0, 20, 50, 0.1)',
                backdropFilter: 'blur(2px)',
                zIndex: 0
            }} />

            {/* Header / Gamification Bar (Faixa Horizontal no Topo) */}
            <div
                className="w-100 position-relative shadow-lg flex-shrink-0"
                style={{
                    backgroundColor: 'rgba(0, 15, 30, 0.5)',
                    backdropFilter: 'blur(15px)',
                    minHeight: '140px',
                    display: 'flex',
                    borderBottom: '1px solid rgba(255,255,255,0.1)'
                }}
            >
                {/* Overlay Escuro para Legibilidade */}
                <div style={{
                    position: 'absolute',
                    top: 0, left: 0, right: 0, bottom: 0,
                    background: 'linear-gradient(90deg, rgba(0,0,0,0.6) 0%, rgba(10,25,50,0.4) 50%, rgba(0,0,0,0.6) 100%)',
                    zIndex: 1
                }} />

                {/* HEADER DESKTOP (Idêntico ao original) */}
                <div className="container-fluid px-3 py-2 position-relative d-none d-md-flex flex-row align-items-center justify-content-between gap-2" style={{ zIndex: 2 }}>
                    {/* Avatar (Lado Esquerdo) */}
                    <div className="d-flex flex-row align-items-center gap-2" style={{ maxWidth: "65%" }}>
                        <div className="d-flex align-items-center gap-2">
                            {/* Avatar Circular com Borda XP */}
                            <div
                                className="rounded-circle d-flex align-items-center justify-content-center shadow-lg bg-dark flex-shrink-0 overflow-hidden"
                                style={{
                                    width: "80px",
                                    height: "80px",
                                    border: "3px solid #f1b44c", // Borda dourada XP mais visível
                                    backgroundColor: "rgba(255,255,255,0.1)"
                                }}
                            >
                                {photo ? (
                                    <img src={photo} alt={name} className="img-fluid w-100 h-100" style={{ objectFit: 'cover' }} />
                                ) : (
                                    <span className="text-white fw-bold font-size-32">
                                        {name.charAt(0).toUpperCase()}
                                    </span>
                                )}
                            </div>

                            {/* Informações de Nome e Rank */}
                            <div>
                                <h4 className="fw-bold text-white mb-0 shadow-sm"
                                    style={{
                                        letterSpacing: "-0.5px",
                                        fontSize: name.length > 25 ? "1.4rem" : name.length > 15 ? "1.6rem" : "2rem",
                                        lineHeight: "1.2",
                                        wordBreak: "break-word"
                                    }}>
                                    {name}
                                </h4>
                                <div className="d-flex align-items-center gap-1 mt-1">
                                    <span className="badge px-3 py-1 font-size-14 fw-bold text-uppercase rounded-pill" style={{ backgroundColor: '#f1b44c', color: '#000', boxShadow: '0 2px 4px rgba(0,0,0,0.3)' }}>
                                        <i className="mdi mdi-star me-1"></i> {level}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Logo e Informações de Gamificação (Lado Direito) */}
                    <div className="d-flex flex-row align-items-center justify-content-end flex-shrink-0">
                        {/* Indicador de XP */}
                        <div className="d-flex flex-row align-items-center bg-dark rounded-pill px-2 py-1 shadow-sm border" style={{ borderColor: 'rgba(241, 180, 76, 0.3)', backgroundColor: 'rgba(0,0,0,0.5) !important' }}>
                            <div className="avatar-sm d-flex align-items-center justify-content-center bg-warning bg-opacity-25 rounded-circle me-1" style={{ width: '40px', height: '40px' }}>
                                <i className="mdi mdi-trophy text-warning font-size-22"></i>
                            </div>
                            <div className="text-end pe-2">
                                <h6 className="text-white-50 text-uppercase fw-bold mb-0" style={{ fontSize: "12px", letterSpacing: "1px" }}>Pontos</h6>
                                <h4 className="text-warning fw-bold mb-0 d-flex align-items-baseline gap-1" style={{ fontSize: "1.6rem", textShadow: "0 2px 5px rgba(0,0,0,0.5)" }}>
                                    {points} <span className="font-size-14 text-white-50 fw-normal">XP</span>
                                </h4>
                            </div>
                        </div>
                    </div>
                </div>

                {/* HEADER MOBILE (Adaptado) */}
                <div className="container-fluid px-3 py-3 position-relative d-flex d-md-none flex-column align-items-center justify-content-center gap-3 text-center" style={{ zIndex: 2 }}>

                    {/* Avatar e Nome Empilhados */}
                    <div className="d-flex flex-column align-items-center gap-3 w-100">
                        {/* Avatar Circular com Borda XP */}
                        <div
                            className="rounded-circle d-flex align-items-center justify-content-center shadow-lg bg-dark flex-shrink-0 overflow-hidden"
                            style={{
                                width: "90px",
                                height: "90px",
                                border: "3px solid #f1b44c", // Borda dourada XP mais visível
                                backgroundColor: "rgba(255,255,255,0.1)"
                            }}
                        >
                            {photo ? (
                                <img src={photo} alt={name} className="img-fluid w-100 h-100" style={{ objectFit: 'cover' }} />
                            ) : (
                                <span className="text-white fw-bold font-size-32">
                                    {name.charAt(0).toUpperCase()}
                                </span>
                            )}
                        </div>

                        {/* Informações de Nome e Rank */}
                        <div>
                            <h4 className="fw-bold text-white mb-0 shadow-sm"
                                style={{
                                    letterSpacing: "-0.5px",
                                    fontSize: name.length > 25 ? "1.4rem" : name.length > 15 ? "1.6rem" : "2rem",
                                    lineHeight: "1.2",
                                    wordBreak: "break-word"
                                }}>
                                {name}
                            </h4>
                            <div className="d-flex align-items-center justify-content-center gap-1 mt-2">
                                <span className="badge px-3 py-1 font-size-14 fw-bold text-uppercase rounded-pill" style={{ backgroundColor: '#f1b44c', color: '#000', boxShadow: '0 2px 4px rgba(0,0,0,0.3)' }}>
                                    <i className="mdi mdi-star me-1"></i> {level}
                                </span>
                            </div>
                        </div>
                    </div>

                    {/* Logo e Informações de Gamificação */}
                    <div className="d-flex flex-row align-items-center justify-content-center flex-shrink-0 w-100 mt-2">
                        {/* Indicador de XP */}
                        <div className="d-flex flex-row align-items-center bg-dark rounded-pill px-2 py-1 shadow-sm border" style={{ borderColor: 'rgba(241, 180, 76, 0.3)', backgroundColor: 'rgba(0,0,0,0.5) !important' }}>
                            <div className="avatar-sm d-flex align-items-center justify-content-center bg-warning bg-opacity-25 rounded-circle me-1" style={{ width: '40px', height: '40px' }}>
                                <i className="mdi mdi-trophy text-warning font-size-22"></i>
                            </div>
                            <div className="text-end pe-2">
                                <h6 className="text-white-50 text-uppercase fw-bold mb-0" style={{ fontSize: "12px", letterSpacing: "1px" }}>Pontos</h6>
                                <h4 className="text-warning fw-bold mb-0 d-flex align-items-baseline gap-1" style={{ fontSize: "1.6rem", textShadow: "0 2px 5px rgba(0,0,0,0.5)" }}>
                                    {points} <span className="font-size-14 text-white-50 fw-normal">XP</span>
                                </h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Tabs de Navegação */}
            <div className="container mt-4 position-relative px-3" style={{ zIndex: 2 }}>

                {/* TABS DESKTOP (Efeito Frosted Glass High End) */}
                <Nav pills className="navtab-bg nav-justified shadow-sm rounded-pill p-1 mx-2 mb-3 d-none d-md-flex" style={{ backgroundColor: "rgba(255, 255, 255, 0.85)", backdropFilter: "blur(12px)", border: "1px solid rgba(255,255,255,0.7)" }}>
                    <NavItem>
                        <NavLink
                            style={{ cursor: "pointer", transition: "all 0.3s", background: activeTab === 'avaliacao' ? 'linear-gradient(135deg, #0f2027, #203a43, #2c5364)' : 'transparent', color: activeTab === 'avaliacao' ? '#fff' : '#111', boxShadow: activeTab === 'avaliacao' ? '0 4px 10px rgba(0,0,0,0.3)' : 'none' }}
                            className="fw-bold rounded-pill py-3 font-size-18"
                            onClick={() => setActiveTab('avaliacao')}
                        >
                            <i className="mdi mdi-chart-bar me-2"></i> Meu Desempenho
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            style={{ cursor: "pointer", transition: "all 0.3s", background: activeTab === 'conquistas' ? 'linear-gradient(135deg, #0f2027, #203a43, #2c5364)' : 'transparent', color: activeTab === 'conquistas' ? '#fff' : '#111', boxShadow: activeTab === 'conquistas' ? '0 4px 10px rgba(0,0,0,0.3)' : 'none' }}
                            className="fw-bold rounded-pill py-3 font-size-18"
                            onClick={() => setActiveTab('conquistas')}
                        >
                            <i className="mdi mdi-shield-star me-2"></i> Conquistas
                        </NavLink>
                    </NavItem>
                </Nav>

                {/* TABS MOBILE (Adaptado - Lado a Lado - Efeito Frosted Glass High End) */}
                <Nav pills className="navtab-bg flex-row nav-justified shadow-sm rounded-pill p-1 mb-3 d-flex d-md-none w-100" style={{ backgroundColor: "rgba(255, 255, 255, 0.85)", backdropFilter: "blur(12px)", border: "1px solid rgba(255,255,255,0.7)" }}>
                    <NavItem className="w-50">
                        <NavLink
                            style={{ cursor: "pointer", transition: "all 0.3s", background: activeTab === 'avaliacao' ? 'linear-gradient(135deg, #0f2027, #203a43, #2c5364)' : 'transparent', color: activeTab === 'avaliacao' ? '#fff' : '#111', boxShadow: activeTab === 'avaliacao' ? '0 4px 10px rgba(0,0,0,0.3)' : 'none', fontSize: '14px', padding: '12px 4px' }}
                            className="fw-bold rounded-pill d-flex flex-column align-items-center justify-content-center text-center h-100"
                            onClick={() => setActiveTab('avaliacao')}
                        >
                            Meu Desempenho
                        </NavLink>
                    </NavItem>
                    <NavItem className="w-50">
                        <NavLink
                            style={{ cursor: "pointer", transition: "all 0.3s", background: activeTab === 'conquistas' ? 'linear-gradient(135deg, #0f2027, #203a43, #2c5364)' : 'transparent', color: activeTab === 'conquistas' ? '#fff' : '#111', boxShadow: activeTab === 'conquistas' ? '0 4px 10px rgba(0,0,0,0.3)' : 'none', fontSize: '14px', padding: '12px 4px' }}
                            className="fw-bold rounded-pill d-flex flex-column align-items-center justify-content-center text-center h-100"
                            onClick={() => setActiveTab('conquistas')}
                        >
                            Conquistas
                        </NavLink>
                    </NavItem>
                </Nav>
            </div>

            <TabContent activeTab={activeTab} className="container position-relative" style={{ zIndex: 2, flexGrow: 1 }}>

                {/* ───────────────────────────────────────────────────────── */}
                {/* TAB 1: MEU DESEMPENHO (AVALIAÇÃO TÉCNICA)                 */}
                {/* ───────────────────────────────────────────────────────── */}
                <TabPane tabId="avaliacao">
                    <div style={{
                        backgroundColor: 'rgba(255, 255, 255, 0.85)',
                        backdropFilter: 'blur(16px)',
                        WebkitBackdropFilter: 'blur(16px)',
                        border: '2px solid rgba(255, 255, 255, 0.6)',
                        borderRadius: '24px',
                        boxShadow: '0 16px 40px rgba(0, 0, 0, 0.15)',
                        padding: '16px',
                        marginBottom: '40px'
                    }}>
                        {loadingEval ? (
                            <div className="d-flex justify-content-center py-5">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Carregando...</span>
                                </div>
                            </div>
                        ) : latestEvaluation ? (
                            <div className="p-3">
                                <div className="d-flex justify-content-between align-items-center mb-4">
                                    <div>
                                        <h3 className="mb-0 fw-bold text-dark">{latestEvaluation.eventName || "Avaliação Técnica"}</h3>
                                        <p className="text-muted mb-0 font-size-16">
                                            <i className="mdi mdi-calendar-blank me-1"></i>
                                            {moment(latestEvaluation.date).format("DD/MM/YYYY")}
                                        </p>
                                    </div>
                                    <div className="text-end">
                                        <span className={`badge rounded-pill px-3 py-2 ${latestEvaluation.status === "PASSED" ? "bg-success text-white" : "bg-warning text-dark"} shadow-sm`}>
                                            {latestEvaluation.status === "PASSED" ? (
                                                <><i className="mdi mdi-check-circle me-1"></i> Aprovado</>
                                            ) : (
                                                <><i className="mdi mdi-clock-outline me-1"></i> Em Progresso</>
                                            )}
                                        </span>
                                    </div>
                                </div>

                                <div className="mb-4">
                                    <div className="d-flex justify-content-between align-items-center mb-2 font-size-18">
                                        <span className="fw-bold text-dark">Progresso para o próximo nível</span>
                                        <span className="fw-bold text-primary">{latestEvaluation.progressPercent || 0}%</span>
                                    </div>
                                    <Progress value={latestEvaluation.progressPercent || 0} color="primary" style={{ height: "14px", backgroundColor: "rgba(0,0,0,0.1)" }} />
                                </div>

                                {Object.keys(groupedCriteria).length > 0 && (
                                    <div className="mt-4">
                                        <h5 className="fw-bold text-secondary mb-4 text-uppercase" style={{ letterSpacing: "1px" }}>Critérios Avaliados</h5>
                                        <div className="table-responsive">
                                            <table className="table table-borderless mb-0 bg-transparent" style={{ backgroundColor: 'transparent' }}>
                                                <tbody className="bg-transparent">
                                                    {Object.entries(groupedCriteria).map(([objectiveName, criteriaList], objIdx) => (
                                                        <React.Fragment key={objIdx}>
                                                            <tr className="bg-transparent border-0">
                                                                <td colSpan="2" className="pt-4 pb-2 px-0 bg-transparent">
                                                                    <div className="fw-bold text-dark mb-0" style={{ borderLeft: "5px solid #f1b44c", paddingLeft: "12px", fontSize: "1.4rem" }}>
                                                                        {objectiveName}
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                            {criteriaList.map((criterion, idx) => {
                                                                const uniqueId = `crit-${objIdx}-${idx}`;
                                                                return (
                                                                    <tr key={uniqueId} className="bg-transparent" style={{ borderBottom: "1px solid rgba(0,0,0,0.05)", backgroundColor: 'transparent' }}>
                                                                        <td className="py-2 px-0 bg-transparent align-middle" style={{ backgroundColor: 'transparent', width: '60%', maxWidth: '150px' }}>
                                                                            <div className="d-flex align-items-center flex-wrap gap-1">
                                                                                <div
                                                                                    className="fw-semibold text-dark font-size-16 font-size-md-18 mb-1 mb-md-0"
                                                                                    style={{ wordBreak: 'break-word', whiteSpace: 'normal', lineHeight: '1.2' }}
                                                                                >
                                                                                    {criterion.name}
                                                                                </div>
                                                                                {criterion.isFundamental && (
                                                                                    <span className="badge bg-danger-subtle text-danger font-size-12 mb-1 mb-md-0 d-inline-block" title="Fundamental">Fund.</span>
                                                                                )}
                                                                            </div>
                                                                        </td>
                                                                        <td className="py-2 text-end px-0 align-middle bg-transparent" style={{ backgroundColor: 'transparent', width: '40%', minWidth: '120px' }}>
                                                                            {levels && levels.length > 0 ? (
                                                                                <div className="d-flex flex-column flex-sm-row align-items-end align-items-sm-center justify-content-end gap-1">
                                                                                    <span className="me-sm-3 mb-1 mb-sm-0 font-size-12 font-size-sm-16 fw-bold text-muted text-truncate" style={{ maxWidth: "120px" }}>
                                                                                        {criterion.levelName || "Avaliado"}
                                                                                    </span>
                                                                                    <div className="d-flex gap-1 gap-sm-2" title={criterion.levelName || "Avaliado"}>
                                                                                        {levels.slice(1).map((lvl, lIdx) => {
                                                                                            // Encontra a posição do nível do critério na array total de níveis
                                                                                            const criterionLevelIndex = levels.findIndex(l => String(l.id) === String(criterion.idLevel));

                                                                                            // Se for o 1º nível (index 0), será todos apagados, pois criterionLevelIndex (0) não é > lIdx (que começa em 0).
                                                                                            // Se for o 2º nível (index 1), preenche 1 bloco (lIdx 0).
                                                                                            // Se for o 4º nível "Bom" (index 3), preenche 3 blocos (lIdx 0, 1 e 2).
                                                                                            const isFilled = criterionLevelIndex !== -1 && lIdx < criterionLevelIndex;

                                                                                            return (
                                                                                                <div
                                                                                                    key={`lvl-block-${lvl.id || lIdx}`}
                                                                                                    style={{
                                                                                                        width: 'clamp(14px, 4vw, 24px)',
                                                                                                        height: 'clamp(14px, 4vw, 24px)',
                                                                                                        backgroundColor: isFilled ? '#f1b44c' : 'rgba(0,0,0,0.1)',
                                                                                                        borderRadius: '4px',
                                                                                                        boxShadow: isFilled ? '0 2px 4px rgba(0,0,0,0.2)' : 'none',
                                                                                                        transition: 'all 0.3s ease'
                                                                                                    }}
                                                                                                    title={lvl.name || "Nível"}
                                                                                                />
                                                                                            );
                                                                                        })}
                                                                                    </div>
                                                                                </div>
                                                                            ) : (
                                                                                <span className="fw-bold px-2 px-sm-3 py-1 font-size-12 font-size-sm-14 rounded text-dark border border-secondary border-opacity-25 text-wrap d-inline-block" style={{ backgroundColor: 'transparent', maxWidth: '100%' }}>
                                                                                    {criterion.levelName || "Avaliado"}
                                                                                </span>
                                                                            )}
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            })}
                                                        </React.Fragment>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                )}

                                {latestEvaluation.observations && (
                                    <div className="mt-4 p-3 rounded text-muted border border-secondary border-opacity-25" style={{ backgroundColor: 'transparent' }}>
                                        <strong className="d-block mb-1 text-dark">Observações:</strong>
                                        {latestEvaluation.observations}
                                    </div>
                                )}
                            </div>
                        ) : (
                            <div className="d-flex flex-column align-items-center justify-content-center text-muted text-center p-5" style={{ minHeight: "200px" }}>
                                <h5 className="fw-bold text-dark">Nenhuma Avaliação</h5>
                                <p className="mb-0">Não encontramos avaliações recentes registradas para você.</p>
                            </div>
                        )}
                    </div>
                </TabPane>

                {/* ───────────────────────────────────────────────────────── */}
                {/* TAB 2: CONQUISTAS (TRILHA DE INSÍGNIAS)                     */}
                {/* ───────────────────────────────────────────────────────── */}
                <TabPane tabId="conquistas">
                    <div style={{
                        backgroundColor: 'rgba(255, 255, 255, 0.85)',
                        backdropFilter: 'blur(16px)',
                        WebkitBackdropFilter: 'blur(16px)',
                        border: '2px solid rgba(255, 255, 255, 0.6)',
                        borderRadius: '24px',
                        boxShadow: '0 16px 40px rgba(0, 0, 0, 0.15)',
                        padding: '24px 12px',
                        marginBottom: '40px'
                    }}>
                        <GamificationBadges
                            gamifiedActivities={gamifiedActivities}
                            member={liveMember}
                            achievementsSettings={achievementsSettings}
                            rankSettings={rankSettings}
                            awardedAchievementIds={awardedAchievementIds}
                            awardedAchievements={awardedAchievements}
                        />
                    </div>
                </TabPane>

            </TabContent>

            {/* Botão de Voltar no Canto Inferior Esquerdo */}
            <div className="position-fixed" style={{ bottom: '24px', left: '24px', zIndex: 10 }}>
                <button
                    onClick={onBack}
                    className="btn btn-dark bg-opacity-75 rounded-circle d-flex align-items-center justify-content-center shadow-lg border-0"
                    style={{ width: "64px", height: "64px", backdropFilter: "blur(5px)", transition: "all 0.2s" }}
                    title="Voltar"
                >
                    <i className="mdi mdi-arrow-left text-white" style={{ fontSize: "32px", marginLeft: "-2px" }}></i>
                </button>
            </div>

            {/* Powered By (Canto Inferior Direito) */}
            <div className="position-fixed" style={{ bottom: '24px', right: '24px', zIndex: 10 }}>
                <div className="d-flex align-items-center gap-2 opacity-50">
                    <span style={{ fontSize: "10px", fontWeight: "700", color: "#333", letterSpacing: "1px" }}>POWERED BY</span>
                    <img src={neoLogo} alt="NeoApp" style={{ height: "14px", filter: "grayscale(100%) brightness(0.2)" }} />
                </div>
            </div>
        </div>
    );
};

export default KioskGamificationProfile;
